import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan20-clash-royale',
  templateUrl: './ramadan20-clash-royale.component.html',
  styleUrls: ['./ramadan20-clash-royale.component.css']
})
export class Ramadan20ClashRoyaleComponent implements OnInit {

  gameName = "clash-royale";
  constructor() { }

  ngOnInit() {
  }

}
